(function () {
	'use strict';

	window.js = window.js || {};

	js.focalpoint = (function() {
	
		var
			_domElm;


		function initialize(domElm) {
			_domElm = domElm;

			if (domElm.dataset.focalpointX) {
				var config = {
					focalpointX: parseInt(domElm.dataset.focalpointX, 10),
					focalpointY: parseInt(domElm.dataset.focalpointY, 10),
					alignment: domElm.dataset.themeAlignment,
					opaque: domElm.dataset.opaque === 'true',
					layout: domElm.dataset.teaserLayout
				};
				if (config.layout === 'full-deck') {
					adjustFocalPointFullDeck(domElm, config);
				}
				
			}
		}

		function removeTransparencyClasses(elm) {
			if (!elm) {
				// guard
				return;
			}
			var
				transparencyRegex = /-trans-/;
			
			

			Array.prototype.slice.call(elm.classList).forEach(function (cl) {
				//console.log('class:', cl);
				if (transparencyRegex.test(cl)) {
					elm.classList.remove(cl);
					elm.classList.add(cl.replace(transparencyRegex, '-'));
				}
			});
		}

		function adjustFocalPointFullDeck(domElm, config) {
			if (config.opaque) {
				// the overlay is opaque, so the focal point has already been handled by the image preset. guard.
				return;
			}

			if ((config.alignment === 'left' && config.focalpointX < 56) || (config.alignment === 'right' && config.focalpointX > 44)) {
				// overlay is to the left and focal point is NOT positioned in the rightmost 30% of the image OR 
				// the overlay is to the right and the focal point is NOT positioned in the leftmost 30% of the image. 
				// In any case, disable the transparency and change the image preset
				//console.log('changing the image preset and disabling transparency');
				//console.log(config);
				var
					imgContainer = domElm.querySelector('.js-teaser-image');
				var
					style;
				if (!imgContainer) {
					return;
				}
				style = 'background-image: ' + domElm.dataset.imgPortrait + ';';
				imgContainer.setAttribute('style', style);
				
				// now remove transparency
				removeTransparencyClasses(imgContainer);
				removeTransparencyClasses(domElm.querySelector('.js-teaser-overlay'));
			}



		}


		return {
			initialize: initialize
		};
	})();
})();